// LLM models data for the Background tab
export const llmModels = [
  {
    name: "Claude 4 Sonnet",
    strengths: "Superior coding, balanced performance & efficiency, precise instruction following",
    useCase: "Production workflows, customer-facing agents, real-time coding tasks, high-volume applications",
    features: "200K context window, hybrid reasoning (instant + extended thinking), parallel tool use, enhanced memory capabilities"
  },
  {
    name: "Claude 4 Opus",
    strengths: "World's best coding model, sustained long-running tasks, frontier AI agents",
    useCase: "Complex agent workflows, multi-hour autonomous tasks, advanced research, scientific discovery",
    features: "200K context window, extended thinking up to 64K tokens, superior memory management, 7+ hour continuous operation"
  },
  {
    name: "GPT-o3 (OpenAI)",
    strengths: "Coding, math, science, visual reasoning",
    useCase: "Complex problem-solving, visual tasks",
    features: "Image-integrated reasoning, tool usage (web search, Python, image generation), high accuracy"
  },
  {
    name: "GPT-4o (OpenAI)",
    strengths: "Natural, multimodal communication",
    useCase: "Chatting, real-time voice, image recognition, writing",
    features: "Seamless voice + image + text, up to 128k context, quick and highly interactive"
  },
  {
    name: "xAI Grok-3",
    strengths: "Staying current with real-world events",
    useCase: "News discussions, trending topics, fresh analysis",
    features: "Web-connected, up-to-date insights, 128k context window"
  },
  {
    name: "DeepSeek R1",
    strengths: "Precision thinking on technical tasks",
    useCase: "Coding help, math problems, structured instructions",
    features: "Accurate and efficient, supports up to 131k tokens, cost-effective"
  },
  {
    name: "Gemini 2.5 Pro",
    strengths: "Advanced multimodal reasoning",
    useCase: "Complex coding, mathematical problems, multimodal analysis",
    features: "Processes text, audio, images, video, and code; 1M token context (expanding to 2M)"
  },
  {
    name: "LLaMA 4",
    strengths: "Advanced reasoning, multimodal tasks, customization",
    useCase: "Research, custom AI development, open-source projects",
    features: "Enhanced multimodal support, larger context window, open-source flexibility"
  }
]; 